import React from 'react';

function TopBar () {
  return (
    <div className='mdl-layout__header'>
      <div className='mdl-layout__header-row'>
        <span className='mdl-layout-title'>Bitcoin Core Config Generator (compatible with Bitcoin Core 24.0)</span>
        <div className='mdl-layout-spacer' />
      </div>
    </div>
  );
}

export default TopBar;



/** WEBPACK FOOTER **
 ** ./src/components/TopBar.js
 **/